import addHours from'../addHours/index.js';import toDate from'../toDate/index.js';import requiredArgs from'../_lib/requiredArgs/index.js';/**
 * @name eachHourOfInterval
 * @category Interval Helpers
 * @summary Return the array of hours within the specified time interval.
 *
 * @description
 * Return the array of hours within the specified time interval.
 *
 * @param {Interval} interval - the interval. See [Interval]{@link docs/types/Interval}
 * @param {Object} [options] - an object with options.
 * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
 * @returns {Date[]} the array with starts of hours from the hour of the interval start to the hour of the interval end
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.step` must be a number greater than 1
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each hour between 6 October 2014, 12:00 and 10 October 2014, 15:00
 * var result = eachHourOfInterval({
 *   start: new Date(2014, 9, 6, 12),
 *   end: new Date(2014, 9, 6, 15)
 * })
 * //=> [
 * //   Mon Oct 06 2014 12:00:00,
 * //   Mon Oct 06 2014 13:00:00,
 * //   Mon Oct 06 2014 14:00:00,
 * //   Mon Oct 06 2014 15:00:00
 * // ]
 */export default function eachHourOfInterval(dirtyInterval,options){requiredArgs(1,arguments);var interval=dirtyInterval||{};var startDate=toDate(interval.start);var endDate=toDate(interval.end);var startTime=startDate.getTime();var endTime=endDate.getTime();// Throw an exception if start date is after end date or if any date is `Invalid Date`
if(!(startTime<=endTime)){throw new RangeError('Invalid interval');}var dates=[];var currentDate=startDate;currentDate.setMinutes(0,0,0);var step=options&&'step'in options?Number(options.step):1;if(step<1||isNaN(step))throw new RangeError('`options.step` must be a number greater than 1');while(currentDate.getTime()<=endTime){dates.push(toDate(currentDate));currentDate=addHours(currentDate,step);}return dates;}